import { z, uuidSchema } from '@kc3/validation';
export const AgentRoleSchema = z.enum(['agent', 'supervisor', 'admin']);
export const AgentLifecycleStatusSchema = z.enum(['active', 'inactive', 'deleted']);
export const CreateAgentRequestSchema = z.object({
    userId: uuidSchema,
    extension: z.string().min(1).max(20),
    role: AgentRoleSchema.default('agent'),
    maxConcurrentCalls: z.number().int().min(1).max(10).default(1),
    skills: z.array(uuidSchema).optional(),
});
export const UpdateAgentRequestSchema = z
    .object({
    extension: z.string().min(1).max(20).optional(),
    role: AgentRoleSchema.optional(),
    maxConcurrentCalls: z.number().int().min(1).max(10).optional(),
    skills: z.array(uuidSchema).optional(),
    // Telephony Configuration - Basic Info
    status: z.enum(['active', 'inactive']).optional(),
    ringingTimeout: z.number().int().min(1).optional(),
    password: z.string().optional(),
    callerIdName: z.string().optional(),
    callerIdNumber: z.string().optional(),
    enableDoNotDisturb: z.boolean().optional(),
    enableCallForwarding: z.boolean().optional(),
    callForwardingDestination: z.string().optional(),
    outboundWebHookUrl: z.string().optional().transform((val) => val === '' ? undefined : val),
    maximumNoAnswers: z.number().int().min(1).optional(),
    wrapupTime: z.number().int().min(0).optional(),
    rejectDelayTime: z.number().int().min(0).optional(),
    busyDelayTime: z.number().int().min(0).optional(),
    noAnswerDelayTime: z.number().int().min(0).optional(),
    reserveAgent: z.boolean().optional(),
    // Telephony Configuration - Call Settings
    outboundRoute: z.string().optional(),
    allowOutboundCalling: z.boolean().optional(),
    allowExtensionCalling: z.boolean().optional(),
    autoAnswerIncomingCalls: z.boolean().optional(),
    // Telephony Configuration - Record Settings
    enableRecording: z.boolean().optional(),
    recordStereoFormat: z.boolean().optional(),
    recordingFormat: z.enum(['mp3', 'wav']).optional(),
    allowAgentPause: z.boolean().optional(),
    // Telephony Configuration - Voicemail Settings
    enableVoicemail: z.boolean().optional(),
    voicemailPassword: z.string().optional(),
    emailVoicemail: z.boolean().optional(),
    attachVoicemailWithEmail: z.boolean().optional(),
    keepLocalCopyAfterEmail: z.boolean().optional(),
    voicemailEmailAddress: z.string().optional(),
    // Voicemail - Busy Condition
    enableBusyCondition: z.boolean().optional(),
    busyDestinationType: z.string().optional(),
    busyDestination: z.string().optional(),
    // Voicemail - No-Answer Condition
    enableNoAnswerCondition: z.boolean().optional(),
    noAnswerDestinationType: z.string().optional(),
    noAnswerDestination: z.string().optional(),
    // Voicemail - Offline Condition
    enableOfflineCondition: z.boolean().optional(),
    offlineDestinationType: z.string().optional(),
    offlineDestination: z.string().optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const AgentResponseSchema = z.object({
    id: uuidSchema,
    userId: uuidSchema,
    extension: z.string(),
    role: AgentRoleSchema,
    maxConcurrentCalls: z.number().int(),
    status: AgentLifecycleStatusSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
export const AgentCredentialsResponseSchema = z.object({
    agentId: uuidSchema,
    sipUsername: z.string(),
    sipPassword: z.string(),
});
export const ListAgentsQuerySchema = z.object({
    includeDeleted: z
        .string()
        .optional()
        .transform((v) => v === 'true'),
    role: AgentRoleSchema.optional(),
    search: z.string().optional(),
    userId: uuidSchema.optional(),
});
//# sourceMappingURL=agents.js.map